import React from 'react';
import TrigCalculator from './TrigCalculator';

function App() {
  return (
    <div className="App">
      <TrigCalculator />
    </div>
  );
}

export default App;